export interface IApplicationApi {
  name: string;
  url?: string;
  unauthorizedHandler?: () => void;
  authenticationScheme?: string;
}

export class ApplicationApi {
  public constructor(api: IApplicationApi) {
    this.name = api.name;

    if (api.url) {
      this.url = api.url;
    } else {
      throw new Error(`Api url for '${api.name}' is not defined`);
    }

    this.unauthorizedHandler = api.unauthorizedHandler || (() => {});
    this.authenticationScheme = api.authenticationScheme || "Bearer";
  }

  public name: string;
  public authenticationScheme: string;
  public url?: string;
  public unauthorizedHandler: () => void;
}
